import { useEffect } from 'react';

const DEFAULT_TITLE = 'Teachstone Training, LLC';

function useDocumentTitle(title?: string, fallback: string = DEFAULT_TITLE) {
  useEffect(() => {
    document.title = title || fallback;
  }, [title, fallback]);
}

export default useDocumentTitle;
